import { useCallback, useRef } from 'react';

export const useDebouncedCallback = (callback: Function, delay: number) => {
  const timeout = useRef<number>();

  return useCallback(
    (...args: any) => {
      if (timeout.current != null) {
        clearTimeout(timeout.current);
      }

      timeout.current = window.setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );
};
